export const IDS = {
    BANNER: 'wcux-nxt-notification-banner',
    CONFIRMATION: 'wcux-nxt-notification-confirmation',
    ICON: 'wcux-nxt-notification-icon',
    PROVIDER: 'wcux-nxt-notification-provider',
};
